import { render, staticRenderFns } from "./Separador.vue?vue&type=template&id=0a9a7bb5&lang=pug&"
import script from "./Separador.vue?vue&type=script&lang=js&"
export * from "./Separador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports